﻿export function normalizeSearchText(text) {
    if (!text) return "";

    return text
        .toString()
        .trim()
        .toLowerCase()

        .replaceAll("İ", "i")
        .replaceAll("I", "i")
        .replaceAll("ı", "i")

        .replaceAll("Ğ", "g")
        .replaceAll("ğ", "g")

        .replaceAll("Ü", "u")
        .replaceAll("ü", "u")

        .replaceAll("Ş", "s")
        .replaceAll("ş", "s")

        .replaceAll("Ö", "o")
        .replaceAll("ö", "o")

        .replaceAll("Ç", "c")
        .replaceAll("ç", "c")

        .replace(/[^a-z0-9\s]/g, "")
        .replace(/\s+/g, " ")
        .trim();
}

export function exposeSearchUtilsToWindow() {
    window.normalizeSearchText = normalizeSearchText;
}